/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useContext, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { faBorderAll } from '@fortawesome/free-solid-svg-icons';
import { Container, Row } from 'reactstrap';
import { useLocation } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import operationService from '../../services/operationService';
import {
  QueryGroup,
  OperationItem,
  OperationFilter,
  Assigned,
} from '../../services/types/Operation';
import BasicRadioGroup from '../../shared/components/BasicRadioGroup';
import getCells from './Cells';
import {
  Button,
  ButtonBar,
  CustomDropDown,
  PageHeader,
  Section,
  SpinnerArea,
  Table,
  TablePagination,
  TabBar,
  ConfirmModal,
  CustomModal,
  Modal,
} from '../../shared/components';
import { Cell } from '../../shared/components/Table';
import Context from '../App/MainProvider/context';
import Highlights from './Highlights';
import {
  capitalize,
  findMapped,
  findMapId,
  dateTimeFormat,
  customDateStr,
  dateToCustomDateStr,
} from '../../shared/misc/utils';
import useServiceReducer from '../../shared/hooks/useServiceReducer';
import reducer, { OperAction } from './reducer';
import ColumnChecks from './ColumnChecks';
import CustomFiltersForm from './Operation/CustomFiltersForm';
import SaveCustomFiltersModal from './Operation/SaveCustomFiltersModal';
import {
  CustomFilterForm,
  SaveCustomFilter,
  CustomFilterOperations,
  CustomFilterOptions,
} from '../../services/types/CustomFilter';
import useService from '../../shared/hooks/useService';
import SessionContext from '../App/SessionProvider/context';
import Role from '../../types/role';
import customFilterService from '../../services/customFilterService';
import useQuery from '../../shared/hooks/useQuery';
import IndicatorModal from './IndicatorModal';

const queryGroupLabel = {
  [QueryGroup.All as string]: 'all',
  [QueryGroup.Prep as string]: 'inPreparation',
  [QueryGroup.Exec as string]: 'inExecution',
  [QueryGroup.Cc as string]: 'closedCancelled',
};

const AssignedLabel = {
  [Assigned.AllOp as string]: 'AllOp',
  [Assigned.MyOp as string]: 'MyOp',
  [Assigned.GroupOp as string]: 'GroupOp',
};

const Operations: React.FC = () => {
  const [customFilterModalOpen, setCustomFilterModalOpen] = useState(false);
  const [saveCustomFilterModalOpen, setSaveCustomFiltersModalOpen] = useState(false);
  const [removeFilterModalOpen, setRemoveFilterModalOpen] = useState(false);
  const [selectedCustomFilterId, setSelectedCustomFilterId] = useState<number | undefined>();
  const [selectedCustomFilterName, setSelectedCustomFilterName] = useState<string | undefined>();
  const { t } = useTranslation();

  const queryParams = useQuery();
  const q = (key: string) => {
    const p = queryParams.get(key);
    if (p) {
      if (p === 'null') {
        return null;
      }
      if (p === 'false') {
        return false;
      }
      if (p === 'true') {
        return true;
      }
      return p;
    }
    return null;
  };
  const paramGroup = q('group');
  const paramAssigned = q('assigned');
  const paramSubType = q('type');

  const { service, user, notify } = useContext(Context);
  const {
    operations: {
      getHideColumns,
      getRemoveColumns,
      currentFilter,
      setColumns,
      setOrder,
      isOperRole,
      setFilter,
    },
  } = useContext(SessionContext);

  const cFilter = {
    ...currentFilter,
    queryGroup: paramGroup || currentFilter.queryGroup,
    assigned: paramAssigned === null ? currentFilter.assigned : paramAssigned,
    subqueryType: paramSubType || currentFilter.subqueryType,
  } as OperationFilter;

  const [data, loading, filter, dispatch, loader, reload] = useServiceReducer(
    operationService.getOperations,
    reducer,
    cFilter
  );
  const [customFilterMetaData, loadingCustomFilterMetaData] = useService(
    customFilterService.getMetadata
  );
  const { queryGroup: selectedQueryGroup, assigned: selectedAssigned } = filter;
  const [excelLoading, setExcelLoading] = useState(false);
  const [unsavedCustomFilter, setUnsavedCustomFilter] = useState<any>();
  const [isUnsavedCustomerfilter, setIsUnsavedCustomerfilter] = useState<any | undefined>();
  const [customFilterState, setCustomFilterState] = useState<any | undefined>();
  const [currentOperation, setCurrentOperation] = useState<any | undefined>();
  const columnsConfig = useRef<{
    cells: Cell<OperationItem>[];
    filter: { hideColumns: string[]; removeColumns: string[] };
  }>({
    cells: [],
    filter: { hideColumns: [], removeColumns: [] },
  });
  const customFilterConfig = useRef<{ filter: { hideColumns: string[] } }>({
    filter: { hideColumns: [] },
  });

  const [showRationaleModal, setShowRationaleModal] = useState(false);
  const [showIndicatorsModal, setShowIndicatorsModal] = useState(false);
  const [currentRationaleType, setcurrentRationaleType] = useState<string>('rationale');
  const [currentRationaleText, setCurrentRationaleText] = useState<string>();
  const [currentOperationIndicator, setcurrentOperationIndicator] = useState<number>(0);
  const [currentQueryDate, setcurrentQueryDate] = useState<Date | null>(null);

  const showRationale = (rationalType: string, rationaleText: string) => {
    setcurrentRationaleType(rationalType);
    setCurrentRationaleText(rationaleText);
    setShowRationaleModal(true);
  };

  const showIndicators = (operationId: number) => {
    setcurrentOperationIndicator(operationId);
    setcurrentQueryDate(
      currentFilter !== null &&
        currentFilter.customFilters !== null &&
        currentFilter.customFilters !== undefined &&
        currentFilter.customFilters.queryDate !== undefined
        ? currentFilter.customFilters.queryDate
        : null
    );
    setShowIndicatorsModal(true);
  };
  const cells = getCells(showRationale, showIndicators);
  columnsConfig.current.cells = cells;

  // Copy previous subqueryType configuration
  if (filter.subqueryType !== 'customFilters') {
    columnsConfig.current.filter.hideColumns = filter.hideColumns;
    columnsConfig.current.filter.removeColumns = filter.removeColumns;
  }

  customFilterConfig.current.filter.hideColumns = filter.hideColumns;

  const queryGroups = [
    { id: 1, text: t('all'), htmlId: 'tabAll', mapped: QueryGroup.All },
    { id: 2, text: t('inPreparation'), htmlId: 'tabPrep', mapped: QueryGroup.Prep },
    { id: 3, text: t('inExecution'), htmlId: 'tabExec', mapped: QueryGroup.Exec },
    { id: 4, text: t('closedCancelled'), htmlId: 'tabCC', mapped: QueryGroup.Cc },
  ];

  const radItems =
    user.roleCode === Role.Specialist || user.secondRoleCode === Role.Specialist
      ? [
          { id: 1, text: t('myOperations'), htmlId: 'radMy', mapped: Assigned.MyOp },
          { id: 2, text: t('allOperations'), htmlId: 'radAll', mapped: Assigned.AllOp },
        ]
      : [
          { id: 1, text: t('myOperations'), htmlId: 'radMy', mapped: Assigned.MyOp },
          { id: 2, text: t('groupOperations'), htmlId: 'radGroup', mapped: Assigned.GroupOp },
          { id: 3, text: t('allOperations'), htmlId: 'radAll', mapped: Assigned.AllOp },
        ];

  const openCustomFilterModal = () => setCustomFilterModalOpen(true);
  const closeCustomFilterModal = () => setCustomFilterModalOpen(false);
  const openSaveCustomFiltersModal = () => setSaveCustomFiltersModalOpen(true);
  const closeSaveCustomFiltersModal = () => setSaveCustomFiltersModalOpen(false);

  const send = (type: string, rest?: Record<string, unknown>) => {
    const action = { type, setFilter, ...rest } as OperAction;
    dispatch(action);
  };

  const handleDeleteCustomFilter = (customFilterId: number, customFilterName: string) => {
    setSelectedCustomFilterId(customFilterId);
    setSelectedCustomFilterName(customFilterName);
    setRemoveFilterModalOpen(true);
  };

  const esgGroups =
    data && data.memberGroups
      ? data.memberGroups.map((x, i) => ({
          id: i + 1,
          text: x.name,
          mapped: x.id,
          htmlId: `filterGroup${x.id}`,
        }))
      : undefined;

  const customFilterSubItems =
    data && data.customFilters
      ? data.customFilters
          .filter(
            (x) =>
              (x.queryGroup === selectedQueryGroup && x.assigned === selectedAssigned) ||
              !(x.id > 0)
          )
          .map((x) =>
            x.id > 0
              ? {
                  id: x.id,
                  text: x.name,
                  mapped: x.id,
                  htmlId: `filterGroup${x.id}`,
                  subItemsCallback: handleDeleteCustomFilter,
                }
              : { id: x.id, text: x.name, mapped: x.id, htmlId: `filterGroup${x.id}` }
          )
      : undefined;

  if (
    customFilterSubItems &&
    unsavedCustomFilter &&
    unsavedCustomFilter.queryGroup === selectedQueryGroup &&
    unsavedCustomFilter.assigned === selectedAssigned
  ) {
    customFilterSubItems.push({
      id: CustomFilterOptions.UnsavedCustomFilter,
      text: 'Unsaved Filter',
      mapped: CustomFilterOptions.UnsavedCustomFilter,
      htmlId: `filterGroup${CustomFilterOptions.UnsavedCustomFilter}`,
      subItemsCallback: handleDeleteCustomFilter,
    });
  }

  const queryItems = [
    { id: 1, text: t('all'), mapped: null, htmlId: 'subAll', noWrapText: true },
    { id: 2, text: t('withMemberAssigned'), mapped: 'assigned', htmlId: 'subAssigned' },
    { id: 3, text: t('notMemberAssigned'), mapped: 'notAssigned', htmlId: 'subNotAssigned' },
    { id: 4, text: t('byEsgGroup'), mapped: 'byGroup', htmlId: 'byGroup', subItems: esgGroups },
    {
      id: 5,
      text: t('customFilters'),
      mapped: 'customFilters',
      htmlId: 'customFilters',
      subItems: customFilterSubItems,
    },
  ];

  const setAssigned = (radId: number) => {
    const assigned = findMapped(radItems, radId);
    send('ASSIGNED', {
      role: user.roleCode,
      value: assigned,
      getHideColumns,
      getRemoveColumns,
    });
  };

  const setQueryGroup = (tabId: number) => {
    const queryGroup = findMapped(queryGroups, tabId);
    send('QUERY_GROUP', {
      role: user.roleCode,
      value: queryGroup,
      getHideColumns,
      getRemoveColumns,
    });
  };

  const handleCleanFilter = () => {
    send('CLEAN_APPLIED_CUSTOM_FILTER');
    reload();
  };

  const setSubqueryAssigned = (qId: number, subId?: number) => {
    const queryItem = queryItems.find((x) => x.id === qId);
    const subqueryType = queryItem!.mapped;
    const subqueryId =
      queryItem && queryItem!.subItems
        ? queryItem.subItems.find((x) => x.id === subId)!.mapped
        : null;

    if (subqueryType === 'customFilters') {
      send('SET_SUBQUERY', { value: subqueryType, id: subqueryId });

      if (subId === CustomFilterOptions.NewCustomFilter) {
        setIsUnsavedCustomerfilter(false);
        setCustomFilterState(null);
        openCustomFilterModal();
      } else if (subId === CustomFilterOptions.CleanCustomFilter) {
        handleCleanFilter();
      } else if (subId === CustomFilterOptions.UnsavedCustomFilter) {
        setIsUnsavedCustomerfilter(true);
        setCustomFilterState(unsavedCustomFilter);
        openCustomFilterModal();
      } else {
        send('SUBQUERY_ASSIGNED', {
          value: subqueryType,
          id: subqueryId,
          getHideColumns,
          getRemoveColumns,
          customFilterId: subId,
        });
      }
    } else {
      send('SUBQUERY_ASSIGNED', {
        value: subqueryType,
        id: subqueryId,
        getHideColumns,
        getRemoveColumns,
      });
    }
  };

  const changePage = (page: number) => send('PAGE', { value: page });

  const changePageSize = (size: number) => send('PAGE_SIZE', { value: size });

  const setColumnOrder = (sortField: string, sortDescending: boolean) => {
    const orderFilter = { ...filter, sortField, sortDescending };
    setOrder(orderFilter);
    send('ORDER', { column: sortField, descending: sortDescending });
  };

  const setHideColumn = (id: string, checked: boolean) => {
    if (id === 'number') {
      return;
    }
    send('HIDE_COLUMN', { column: id, checked, setColumns });
  };

  const exportExcel = () => {
    let hiddenCols =
      filter.subqueryType !== 'customFilters'
        ? [
            ...columnsConfig.current.filter.hideColumns.map((x) => capitalize(x)),
            ...columnsConfig.current.filter.removeColumns.map((x) => capitalize(x)),
          ]
        : [...customFilterConfig.current.filter.hideColumns.map((x) => capitalize(x))];

    hiddenCols = hiddenCols.filter((x, i, a) => a.indexOf(x) === i);

    const colsWithDependsOn = columnsConfig.current.cells.filter((x) => x.dependsOn);

    colsWithDependsOn.forEach((element) => {
      const indexDependsOn = element.dependsOn
        ? hiddenCols.indexOf(capitalize(element.dependsOn))
        : -1;

      if (indexDependsOn === -1 && element.name) {
        const indexCol = hiddenCols.indexOf(capitalize(element.name));
        if (indexCol > -1) {
          hiddenCols.splice(indexCol, 1);
        }
      }
    });

    const excelParam = { ...filter, pageSize: 0, pageNumber: 1, hideColumns: hiddenCols };
    service(() => operationService.exportExcel(excelParam), { loader: setExcelLoading });
  };

  const getSubqueryId = () => {
    const sqType = queryItems.find((x) => x.mapped === filter.subqueryType);
    if (sqType && sqType.subItems) {
      return sqType.subItems.find((x) => x.mapped === filter.subqueryId) || null;
    }

    return null;
  };

  const getQueryDate = (fecha: Date | null) => {
    const formated = dateToCustomDateStr(fecha);
    if (formated === null) {
      return '';
    }
    return formated;
  };

  const subqueryTypeSelected = queryItems.find((x) => x.mapped === filter.subqueryType);

  const handleCustomFilterSubmit = (
    values: CustomFilterForm,
    customFilterOperation: CustomFilterOperations
  ) => {
    const { queryGroup, assigned, subqueryType } = filter;
    setCustomFilterModalOpen(false);
    setCustomFilterState(values);

    const payload = { ...values };
    if (customFilterOperation === CustomFilterOperations.ApplyAndSaveFilter) {
      const operation = {
        assignedText: t(AssignedLabel[assigned]),
        queryGroupText: t(queryGroupLabel[queryGroup]),
      };
      setCurrentOperation(operation);
      openSaveCustomFiltersModal();
    } else if (customFilterOperation === CustomFilterOperations.ApplyFilter) {
      setUnsavedCustomFilter({ ...values, queryGroup, assigned });
      send('ADD_UNSAVED_CUSTOM_FILTER', { customFilters: payload });
    }
    send('SUBQUERY_ASSIGNED', {
      value: subqueryType,
      id: CustomFilterOptions.UnsavedCustomFilter,
      getHideColumns,
      getRemoveColumns,
      customFilters: payload,
    });
  };

  const handleSaveCustomFilterSubmit = (
    values: SaveCustomFilter,
    resetFormCallback: () => void
  ) => {
    const { name } = values;
    const { queryGroup, assigned, subqueryType } = filter;

    const payload: SaveCustomFilter = {
      email: user.email,
      customFilters: customFilterState,
      assigned,
      queryGroup,
      name,
    };

    const callback = (customFilterRes: SaveCustomFilter | null) => {
      setCustomFilterState(null);
      if (isUnsavedCustomerfilter) {
        setUnsavedCustomFilter(null);
        send('DELETE_UNSAVED_CUSTOM_FILTER');
        // after delete UNSAVED filter, clean grid.
      }

      closeSaveCustomFiltersModal();
      resetFormCallback();

      if (customFilterRes) {
        const newCustomFilter = {
          id: customFilterRes.id,
          userId: customFilterRes.userId,
          customFilters: null,
          assigned: customFilterRes.assigned,
          queryGroup: customFilterRes.queryGroup,
          name: customFilterRes.name,
        };
        send('ADD_NEW_CUSTOM_FILTER', { newCustomFilter });
        send('SUBQUERY_ASSIGNED', {
          value: subqueryType,
          id: customFilterRes.id,
          getHideColumns,
          getRemoveColumns,
          customFilterId: customFilterRes.id,
        });
        notify('Custom Filter', t('successSave'), 'success');
      } else {
        notify('Custom Filter', t('saveFail'), 'danger');
      }
    };

    service(() => customFilterService.saveCustomFilter(payload), { callback });
  };

  const handleDeleteFilter = () => {
    const customFilterId = selectedCustomFilterId;
    if (customFilterId === CustomFilterOptions.UnsavedCustomFilter) {
      setUnsavedCustomFilter(null);
      send('DELETE_UNSAVED_CUSTOM_FILTER');
      loader(true);
      reload();
      return;
    }

    loader(true);

    const callback = (customFilterRes: boolean) => {
      if (customFilterRes) {
        send('DELETE_CUSTOM_FILTER', { customFilterId });
        reload();
        notify('Delete Custom Filter', t('successDelete'), 'success');
      } else {
        loader(false);
        notify('Delete Custom Filter', t('saveFail'), 'danger');
      }
    };
    if (customFilterId) {
      service(() => customFilterService.deleteCustomFilter(customFilterId), { callback });
    }
  };

  const availableCustomFilterFields = columnsConfig.current.cells.map(
    (cell) => cell.name as string
  );

  useEffect(() => {
    // it's not customFilters
    if (filter.subqueryType !== 'customFilters') {
      return;
    }

    // it's customFilters and saved custom filter
    if (filter.subqueryType === 'customFilters' && filter.customFilterId && !filter.customFilters) {
      return;
    }

    send('DELETE_UNSAVED_CUSTOM_FILTER');
    reload();
  }, []);

  const lastUpdateInfo = data && data.lastUpdateDate && (
    <FontAwesomeIcon
      icon="info-circle"
      title={t('lastUpdateOperationList', {
        date: dateTimeFormat(data.lastUpdateDate),
      })}
      className="lastUpdateInfo"
    />
  );

  return (
    <>
      <Container className="dashboard">
        <PageHeader title="Operations" link={lastUpdateInfo} />
        <Row>
          <Section>
            <div className="header-controls">
              {(user.roleCode === Role.GroupHead ||
                user.secondRoleCode === Role.GroupHead ||
                user.roleCode === Role.Specialist ||
                user.secondRoleCode === Role.Specialist) && (
                <BasicRadioGroup
                  name="select"
                  elements={radItems}
                  onChange={setAssigned}
                  value={findMapId(radItems, filter.assigned)}
                />
              )}
              <TabBar
                id="queryGroupTabBar"
                tabSelected={findMapId(queryGroups, filter.queryGroup)}
                setTabSelected={setQueryGroup}
                headers={queryGroups}
              />
            </div>
            <div>
              <div className="details-bar">
                <div className="content">
                  <h4>
                    {data &&
                      t('showingOperations', { from: data.from, to: data.to, total: data.total })}
                  </h4>
                </div>
                {data && <Highlights highlightGroups={data.highlightGroups} />}
              </div>
              <div className="button-container-bar">
                <div className="button-container-bar--left">
                  <h5>{t('view')}:</h5>
                  <ButtonBar
                    id="queries"
                    value={subqueryTypeSelected!.id}
                    subValue={
                      subqueryTypeSelected && subqueryTypeSelected.subItems && getSubqueryId()
                        ? getSubqueryId()!.id
                        : undefined
                    }
                    onChange={setSubqueryAssigned}
                    elements={
                      filter.queryGroup === QueryGroup.All ||
                      filter.assigned === Assigned.MyOp ||
                      filter.assigned === Assigned.GroupOp
                        ? queryItems.filter((qItem) => qItem.id === 5)
                        : queryItems
                    }
                  />
                </div>
                <div className="button-container-bar--right">
                  <CustomDropDown text={t('columns')} icon={faBorderAll} className="oper-columns">
                    <ColumnChecks
                      cells={columnsConfig.current.cells}
                      removeColums={
                        filter.subqueryType !== 'customFilters'
                          ? columnsConfig.current.filter.removeColumns
                          : []
                      }
                      hideColumns={
                        filter.subqueryType !== 'customFilters'
                          ? columnsConfig.current.filter.hideColumns
                          : customFilterConfig.current.filter.hideColumns
                      }
                      setHideColumn={setHideColumn}
                    />
                  </CustomDropDown>
                  <Button
                    htmlId="btnExcel"
                    text={t('exportToExcel')}
                    onClick={exportExcel}
                    icon="file-excel"
                    className="btn-tertiary"
                  />
                </div>
              </div>
              <SpinnerArea loading={loading || excelLoading}>
                {data && (
                  <>
                    <Table
                      data={data.list}
                      cells={columnsConfig.current.cells}
                      keyFunc={(x) => x.id}
                      hide={
                        filter.subqueryType !== 'customFilters'
                          ? [
                              ...columnsConfig.current.filter.hideColumns,
                              ...columnsConfig.current.filter.removeColumns,
                            ]
                          : customFilterConfig.current.filter.hideColumns
                      }
                      sortData={filter}
                      changeSort={setColumnOrder}
                    />

                    <TablePagination
                      pageSize={filter.pageSize}
                      pageNumber={filter.pageNumber}
                      total={data.total}
                      onChangePage={changePage}
                      onChangeSize={changePageSize}
                    />
                  </>
                )}
              </SpinnerArea>
            </div>
          </Section>
        </Row>
      </Container>
      <CustomModal
        title={t('modalCustomFilterTitle')}
        titleUnderline
        visible={customFilterModalOpen}
        setVisible={setCustomFilterModalOpen}
        customClass="modal-dialog--header-custom-filter"
      >
        {customFilterMetaData && (
          <CustomFiltersForm
            handleSubmit={handleCustomFilterSubmit}
            handleCancel={closeCustomFilterModal}
            formState={customFilterState}
            customFilterMetaData={customFilterMetaData}
            availableFields={availableCustomFilterFields}
          />
        )}
      </CustomModal>
      <SaveCustomFiltersModal
        size="sm"
        visible={saveCustomFilterModalOpen}
        currentOperation={currentOperation}
        setVisible={setSaveCustomFiltersModalOpen}
        handleSubmit={handleSaveCustomFilterSubmit}
        handleCancel={closeSaveCustomFiltersModal}
      />
      <ConfirmModal
        title={t('deleteCumtomFilter')}
        visible={removeFilterModalOpen}
        setVisible={setRemoveFilterModalOpen}
        action={handleDeleteFilter}
      >
        {t('deleteFilterConfirmationPart1')}
        <b>{selectedCustomFilterName}</b>
        {t('deleteFilterConfirmationPart2')}
      </ConfirmModal>
      <Modal
        title={t(currentRationaleType)}
        visible={showRationaleModal}
        setVisible={() => setShowRationaleModal(false)}
        actions={[{ text: 'Close', action: () => setShowRationaleModal(false) }]}
        customClass="extra_wide-modal"
        onClosed={() => setShowRationaleModal(false)}
      >
        <div className="history-content flow-history mb-0 table-responsive">
          <table>
            <tbody>
              <tr>
                <td>{currentRationaleText}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>
      <Modal
        title={t('esgIndicators')}
        visible={showIndicatorsModal}
        setVisible={() => setShowIndicatorsModal(false)}
        actions={[{ text: 'Close', action: () => setShowIndicatorsModal(false) }]}
        customClass="extra_wide-modal"
        onClosed={() => setShowIndicatorsModal(false)}
      >
        <div className="mb-0 table-responsive">
          <IndicatorModal
            operationId={currentOperationIndicator}
            queryDate={getQueryDate(currentQueryDate)}
          />
        </div>
      </Modal>
    </>
  );
};

export default Operations;
